class MFRExpandingBanner {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {

    };

    this.init();
  }

  init() {
    this.initGsapAnimation();
  }

  initGsapAnimation() {
    gsap.to(this.$element, {
      scale: 1,
      scrollTrigger: {
        trigger: this.$element,
        start: "top 65%",
        end: "top 10%",
        scrub: true
      },
    });
  }
}